<template>
  <div v-if="filterItem">
    <template v-if="node.children">
      <div>
        <b-link class="layer-filter-btn" variant="primary" size="sm" v-b-toggle="'collapse_'+(node.name).replace(/\W+/g, '_')"><span
          :class="'pl-'+level"><span v-if="node.loading" class="loading-icon"><icon name="spinner" pulse></icon></span> {{(node['title'] || node['name']) + (node.children.length ? ' (' + node.children.length + ')' : '')}}
        </span></b-link>
      </div>
    </template>
    <template v-else>
      <div :class="'pl-'+level" @click.stop.prevent="setDetailsItem" class="layer-filter-subitem">
        <span class='info-item'>{{node.name || node.id || node.ident || node.gid}}</span>
      </div>
    </template>
    <template v-if="node.children">
      <!-- WORKAROUND for hiding cost surface fields by default -->
      <b-collapse class="list-item-collapse" :visible="node.name !== 'Cost Surface'"
                  :id="'collapse_'+((node.name || node.id).replace(/\W+/g, '_'))">
        <template v-for="(child, i) in node.children">
          <info-tool-item :node="child" :level="level+1" :opened="!child.children && i === 0"></info-tool-item>
        </template>
      </b-collapse>
    </template>
  </div>
</template>
<script>
  import 'vue-awesome/icons/spinner'

  export default {
    name: 'info-tool-item',
    props: {
      node: {
        default: null
      },
      level: {
        default: 1
      },
      opened: {
        default: false
      }
    },
    methods: {
      setDetailsItem () {
        if (this.node.photos) {
          this.constraintPhotosId = this.node.photos.split(',')
        } else {
          this.constraintPhotosId = null
        }

        this.$store.commit('map/currentInfoItem', this.node)
        if (this.node.parentName) {
          this.$store.commit('map/infoToolLine', this.node.parentName)
        }
      }
    },
    mounted () {
      /*if (this.opened) {
        this.setDetailsItem()
      }*/
    },
    computed: {
      filterItem () {
        let key = this.$store.getters['map/filterInfoKey']
        if (!key) {
          return true
        }
        if (this.node && this.node.isLayer) {
          return this.node.name.toLowerCase().indexOf(key.toLowerCase()) > -1
        }
        return true
      },
      constraintPhotosId: {
        get () {
          return this.$store.getters['map/constraintPhotosId']
        },
        set (val) {
          this.$store.commit('map/constraintPhotosId', val)
        }
      }
    }
  }

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/info/InfoTooltem.vue